import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { injectIntl } from "gatsby-plugin-intl"
import Img from "gatsby-image"

import "./clients.scss"

const AboutClients = ( { intl } ) => {
  const assets = useStaticQuery(
    graphql`
      query getClientAssets {
        clients: allFile( filter: { relativePath: { regex: "/about\/client-.*.png/" } } ) {
          edges {
            node {
              ...clientLogo
            }
          }
        },
        santander: file( relativePath: { eq: "about/client-santander.png" } ) {
          ...clientLogo
        },
        visa: file( relativePath: { eq: "about/client-visa.png" } ) {
          ...clientLogo
        },
        tokstok: file( relativePath: { eq: "about/client-tokstok.png" } ) {
          ...clientLogo
        },
        itau: file( relativePath: { eq: "about/client-itau.png" } ) {
          ...clientLogo
        },
        bradesco: file( relativePath: { eq: "about/client-bradesco.png" } ) {
          ...clientLogo
        },
        somos: file( relativePath: { eq: "about/client-somos.png" } ) {
          ...clientLogo
        },
        veloe: file( relativePath: { eq: "about/client-veloe.png" } ) {
          ...clientLogo
        },
        unilever: file( relativePath: { eq: "about/client-unilever.png" } ) {
          ...clientLogo
        },
        livelo: file( relativePath: { eq: "about/client-livelo.png" } ) {
          ...clientLogo
        },
        vivo: file( relativePath: { eq: "about/client-vivo.png" } ) {
          ...clientLogo
        },
        conectCar: file( relativePath: { eq: "about/client-conect-car.png" } ) {
          ...clientLogo
        },
        uber: file( relativePath: { eq: "about/client-uber.png" } ) {
          ...clientLogo
        },
        bancoOriginal: file( relativePath: { eq: "about/client-banco-original.png" } ) {
          ...clientLogo
        },
        transunion: file( relativePath: { eq: "about/client-transunion.png" } ) {
          ...clientLogo
        },
        heineken: file( relativePath: { eq: "about/client-heineken.png" } ) {
          ...clientLogo
        },
        dsp: file( relativePath: { eq: "about/client-dsp.png" } ) {
          ...clientLogo
        },
        laureate: file( relativePath: { eq: "about/client-laureate.png" } ) {
          ...clientLogo
        },
        cielo: file( relativePath: { eq: "about/client-cielo.png" } ) {
          ...clientLogo
        },
        avon: file( relativePath: { eq: "about/client-avon.png" } ) {
          ...clientLogo
        },
        brastemp: file( relativePath: { eq: "about/client-brastemp.png" } ) {
          ...clientLogo
        }
      }
    `
  )
        //{ TODO: montar lista com array, debug childImageSharp is null
        //  assets.clients.edges.map( node => {
        //    return ( <li><Img fluid={ node.childImageSharp.fluid } /></li> )
        //  }
        //}
  return (
    <div className="block text clients">
      <label className="label">{ intl.formatMessage( { id: "about.clients.label" } ) }</label>
      <div className="slider">
        <ul className="content logos">
          <li className="hidden"><Img fluid={ assets.santander.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.visa.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.itau.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.tokstok.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.bradesco.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.somos.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.veloe.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.unilever.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.livelo.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.vivo.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.conectCar.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.uber.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.bancoOriginal.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.transunion.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.heineken.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.dsp.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.laureate.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.cielo.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.avon.childImageSharp.fluid } /></li>
          <li className="hidden"><Img fluid={ assets.brastemp.childImageSharp.fluid } /></li>
        </ul>
      </div>
    </div>
  )
}

const injected = injectIntl( AboutClients );
export { injected as AboutClients }
